import { Link } from "react-router-dom";
import { AI_CTA, AI_DISCLAIMER } from "../content";
import { AiRichText } from "./AiSection";

/**
 * CTA + 免责声明。对应设计稿第 10 节。
 * 「预约免费评估」跳首页联系表单（/#contact-form，与站内其它 CTA 一致用原生 a 标签）；
 * 「返回解决方案总览」为站内路由用 Link。
 */
export default function AiCta() {
  return (
    <section id="ai-contact" aria-labelledby="ai-cta-h" className="py-14 lg:py-20 scroll-mt-20">
      <div
        className="rounded-3xl px-6 lg:px-12 py-12 lg:py-16 text-center text-white/80 border border-[#4db8ff]/20"
        style={{
          background:
            "radial-gradient(760px 340px at 18% 0%, rgba(26,86,219,0.32), transparent 60%)," +
            "linear-gradient(120deg, #0b1b3d, #060e1e)",
        }}
      >
        <h2 id="ai-cta-h" className="text-2xl lg:text-[2rem] font-bold tracking-tight text-white max-w-3xl mx-auto leading-snug">
          {AI_CTA.title}
        </h2>
        <p className="max-w-3xl mx-auto mt-5 text-sm lg:text-base leading-relaxed">{AI_CTA.desc}</p>
        <div className="flex flex-wrap gap-4 justify-center mt-8">
          <a
            href={AI_CTA.primaryAction.href}
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#1a56db] text-white text-sm font-semibold shadow-[0_10px_28px_rgba(26,86,219,0.22)] hover:bg-[#1549bd] hover:-translate-y-0.5 transition-all duration-200 whitespace-nowrap"
          >
            <i className={AI_CTA.primaryAction.icon}></i>
            {AI_CTA.primaryAction.text}
          </a>
          <Link
            to={AI_CTA.secondaryAction.href}
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-white/8 border border-white/12 text-white text-sm font-semibold backdrop-blur-[6px] hover:bg-white/16 hover:-translate-y-0.5 transition-all duration-200 whitespace-nowrap"
          >
            <i className={AI_CTA.secondaryAction.icon}></i>
            {AI_CTA.secondaryAction.text}
          </Link>
        </div>
        <p className="mt-6 text-xs text-white/55">{AI_CTA.note}</p>
      </div>
      <AiRichText
        segments={AI_DISCLAIMER}
        className="mt-8 p-5 lg:px-6 rounded-[10px] bg-[#f8fafc] border border-dashed border-gray-200 text-xs text-[#64748b] leading-[1.8] [&>strong]:text-[#334155]"
      />
    </section>
  );
}
